document.addEventListener('DOMContentLoaded', () => {
  const menuBtn = document.querySelector('.header__mobile-menu-btn');
  const closeBtn = document.querySelector('.mobile-menu__close-btn');
  const mobileMenu = document.getElementById('MobileMenu');

  if (menuBtn && mobileMenu && closeBtn) {
    menuBtn.addEventListener('click', () => {
      mobileMenu.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });

    closeBtn.addEventListener('click', () => {
      mobileMenu.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  }
});
